/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { ONBOARD_OFFICER } from "../pages/OnboardForm/graphql";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_ONBOARD_TABLE } from "../pages/User/graphql/getOnboardUsersTable.query";
import { EDIT_USER } from "../pages/DisableUserDetails/graphql/editUser.mutation";
import { toast } from "react-hot-toast";
import { REMOVE_USER} from "../pages/DisableUserDetails/graphql/removeUser.mutation";

const MODULE_NAME = "OnboardOfficerService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class OnboardOfficerService {
    private static instance: OnboardOfficerService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): OnboardOfficerService {
        if (!OnboardOfficerService.instance) {
            OnboardOfficerService.instance = new OnboardOfficerService(props);
        }
        return OnboardOfficerService.instance;
    }

    async getOnboardTable(limit: number, skip: number, filter: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");

        try {
            if (client) {
                const res = await client.query({
                    query: GET_ONBOARD_TABLE,
                    variables: {
                        criteria: filter,
                        skip: skip,
                        limit: limit,
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getOnboard Table: ", res?.data);
                if (res) {
                    return res?.data?.getOnboardingTable;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async onBoardOfficer(formData: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `data in from screen`, formData);

        try {
            if (client) {
                let _dept =
                    formData &&
                    Array.isArray(formData?.select2) &&
                    formData?.select2?.length > 0 &&
                    formData?.select2[0]?.value;

                let _org =
                    formData &&
                    Array.isArray(formData?.select1) &&
                    formData?.select1?.length > 0 &&
                    formData?.select1[0]?.value;

                console.log("_dept_dept", _dept);
                console.log("_org_org", _org);

                const officerProfile = {
                    organizationName: _org,
                    departmentName: _dept,
                    officerEmail: formData?.email,
                    officerFamilyName: formData?.familyName,
                    officerGivenName: formData?.givenName,
                    designation: formData?.desgination,
                    rank: formData?.rank,
                    forceNo: formData?.forceNo,
                };
                console.log(
                    "onBoardOfficer()-> officerProfile: ",
                    officerProfile
                );
                const res = await client.mutate({
                    mutation: ONBOARD_OFFICER,
                    variables: {
                        ...officerProfile,
                    },
                    fetchPolicy: "no-cache",
                });
                console.log("result-teset", res);
                log.success(MODULE_NAME, "onBoardOfficer: ", res);
                if (res?.data?.createOnboarding) {
                    return res?.data;
                }
            }
        } catch (err: any) {
            log.blue("onboard officer error", err?.graphQLErrors);
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async editUserDetails(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `EDIT USER Details  data in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: EDIT_USER,
                    variables: {
                        input: data
                    },

                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "EDIT User data: ", res);
                if (res) {
                    return res
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }

    }

    async removeUser(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `remove USER   data in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: REMOVE_USER,
                    variables: {
                        email: data
                    },

                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "EDIT User data: ", res);
                if (res) {
                    return res
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }

    }

}
